const collections = () => {
    $( document ).ready(function() {
        if ($("body").hasClass("list-collections") || $("body").hasClass("collection")) {
            $('.banner-ad-marquee').marquee();
        }

        // $('#shopify-section-collection-thumbnails .collections-list a').on('click', function() {
        //     const collectionHandle = $(this).attr("data-collection-handle");
        //     const elementToScroll = $('#shopify-section-products-list .products-list').find(`[data-collection-handle='${collectionHandle}']`)[0]
        //     $('html, body').animate({
        //         scrollTop: ($(elementToScroll).offset().top)
        //     },500);
        // })
    });
}

export default collections